import ApiInstance from './ApiInstance.js'

export default {
getCities() {
    return ApiInstance({ requiresAuth: false }).get('/get-cities');
  },
}